import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResourcesComponent } from './resources/resources.component';
import { AddUpdateResourceComponent } from './add-update-resource/add-update-resource.component';

const routes: Routes = [
  {
    path: '',
    component: ResourcesComponent,
  },
  {
    path: 'add',
    component: AddUpdateResourceComponent,
  },
  {
    path: 'update/:id',
    component: AddUpdateResourceComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ResourceRoutingModule { }
